import { createApi } from "@reduxjs/toolkit/query/react";
import {
  CinemaHallListResponse,
  CinemaHallLocationResponse,
  QueryParams,
} from "types/index";
import { axiosBaseQuery } from "@picovico/helpers";

export const cinemaHallApi = createApi({
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Booking"],
  reducerPath: "cinemaHall",
  endpoints: (builder) => ({
    getCinemaHallList: builder.query<CinemaHallListResponse, QueryParams>({
      query: (queryData) => ({
        name: "cinema_hall_list",
        method: "GET",
        params: {
          paginate: false,
          ...queryData,
        },
      }),
    }),
    getCinemaHallLocationList: builder.query<
      CinemaHallLocationResponse,
      QueryParams
    >({
      query: (queryData) => ({
        name: "cinema_hall_location_list",
        method: "GET",
        params: {
          ...queryData,
        },
      }),
    }),
  }),
});

export const {
  useGetCinemaHallListQuery,
  useLazyGetCinemaHallListQuery,
  useGetCinemaHallLocationListQuery,
} = cinemaHallApi;
